import React from 'react';

//In Internet Explorer window.clipboardData works and
//incidentally multiline pasting does not
const multilinePasteWorks = !window.clipboardData;

export class IEInputWithMultilinePaste extends React.Component {
  onChange = (e) => {
    e.target.value = removeNewlines(e.target.value);
    if (this.props.onChange) this.props.onChange(e);
  };
  render() {
    return <textarea {...this.props} onChange={this.onChange} rows="1" style={{overflow: "hidden"}}/>;
  }
}

function removeNewlines(str) {
  return str.replace(/(\r?\n|\r)/gm, " ");
}

export const InputWithMultilinePaste = multilinePasteWorks ? "input" : IEInputWithMultilinePaste;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/input/InputWithMultilinePaste.jsx